import { isPlatformBrowser } from "@angular/common";
import {
  Component,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
} from "@angular/core";
import { Observable } from "rxjs";
import { EarnRedeem } from "../../models/earn-redeem";
import { EarnRedeemService } from "../../services/earn-redeem.service";
import {
  SeoService,
  SEOTags,
  PageTitleService,
  PAGE_TITLES,
} from "@myclubrewards/shared";

@Component({
  selector: "myclubrewards-earn-redeem",
  templateUrl: "./earn-redeem.component.html",
  styleUrls: ["./earn-redeem.component.scss"],
})
export class EarnRedeemComponent implements OnInit, OnDestroy {
  earnRedeem$: Observable<EarnRedeem>;

  constructor(
    private earnRedeemService: EarnRedeemService,
    @Inject(PLATFORM_ID) private platformId,
    private seoService: SeoService,
    private pageTitleService: PageTitleService
  ) {
    this.earnRedeem$ = this.earnRedeemService.earnRedeem$;
    this.seoService.updateTags(SEOTags.EARN_REDEEM);
    this.pageTitleService.setTitle(PAGE_TITLES.EARN_REDEEM_PAGE_TITLE);
  }

  ngOnInit() {
    if (!this.earnRedeemService.hasValue()) {
      this.earnRedeemService.queryEarnRedeem();
    }
  }

  ngOnDestroy() {}
}
